<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import InputLabelled from '~/components/elements/input/labelled.svelte';
import { validatePresence } from './validators/presence';
import { validatePublicKey } from './validators/publicKey';
export let name = '';
export let value = '';
export let errorMessage = undefined;
export let valid = false;
export let focus = false;
export let fluid = false;
export let placeholder = undefined;
const validate = (value) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        validatePresence(value);
        validatePublicKey(value);
    }
    catch (errorObject) {
        errorMessage = errorObject.message;
        valid = false;
        return false;
    }
    errorMessage = undefined;
    valid = true;
    return true;
});
</script>

<style type="scss"></style>

<InputLabelled on:changed {name} {fluid} {focus} {placeholder} bind:value isValid={validate} />
